import { getLocalStorageData } from '../../utils/helper';
import { APP_API_URL_V2 } from '../../utils/xhr-instance';
import { axiosInstanceV2 } from '../axios';

export async function createCreditNote(data) {
	const API_URL = `${APP_API_URL_V2}/sales/credit-note`;
	const token = getLocalStorageData();
	return await axiosInstanceV2
		.post(API_URL, data, {
			headers: {
				'Content-Type': 'application/json',
				Authorization: `Bearer ${token?.token}`,
			},
		})
		.then((res) => {
			return res.data;
		})
		.catch((err) => {
			return err?.response?.data;
		});
}
export async function applyInvoiceFromCreditNote(data) {
	const API_URL = `${APP_API_URL_V2}/sales/credit-note/apply`;
	const token = getLocalStorageData();
	return await axiosInstanceV2
		.post(API_URL, data, {
			headers: {
				'Content-Type': 'application/json',
				Authorization: `Bearer ${token?.token}`,
			},
		})
		.then((res) => {
			return res.data;
		})
		.catch((err) => {
			return err?.response?.data;
		});
}
export async function updateCreditNote(id, data) {
	const API_URL = `${APP_API_URL_V2}/sales/credit-note/${id}`;
	const token = getLocalStorageData();

	return await axiosInstanceV2
		.put(API_URL, data, {
			headers: {
				'Content-Type': 'application/json',
				Authorization: `Bearer ${token?.token}`,
			},
		})
		.then((res) => res.data)
		.catch((err) => err?.response?.data || 'Something went wrong');
}
export async function fetchCreditNoteNumber() {
	const token = getLocalStorageData();
	try {
		const { data } = await axiosInstanceV2.get(`${APP_API_URL_V2}/sales/credit-note/number`, {
			headers: {
				Authorization: `Bearer ${token?.token}`,
			},
		});
		return data.data.credit_note;
	} catch (error) {
		throw error?.response?.data;
	}
}
export async function fetchCreditNoteExcessPayment(customerId) {
	const token = getLocalStorageData();
	try {
		const { data } = await axiosInstanceV2.get(
			`${APP_API_URL_V2}/sales/payment-receives/excess-payments?customer_id=${customerId}`,
			{
				headers: {
					Authorization: `Bearer ${token?.token}`,
				},
			},
		);
		return data.data;
	} catch (error) {
		throw error?.response?.data;
	}
}

export async function fetchCustomerInvoice(customerId) {
	const token = getLocalStorageData();
	try {
		const { data } = await axiosInstanceV2.get(
			`${APP_API_URL_V2}/customer/${customerId}/invoices`,
			{
				headers: {
					Authorization: `Bearer ${token?.token}`,
				},
			},
		);
		return data.data.customer;
	} catch (error) {
		throw error?.response?.data;
	}
}
export async function deleteCreditNote(data) {
	const token = getLocalStorageData();
	try {
		await axiosInstanceV2.delete(`${APP_API_URL_V2}/sales/credit-note/delete`, {
			headers: {
				Authorization: `Bearer ${token?.token}`,
			},
			data: data,
		});
	} catch (error) {
		throw error?.response?.data;
	}
}

export async function fetchCreditNoteList(data) {
	const token = getLocalStorageData();
	try {
		const res = await axiosInstanceV2.post(`${APP_API_URL_V2}/sales/credit-note/list`, data, {
			headers: {
				'Content-Type': 'application/json',
				Authorization: `Bearer ${token?.token}`,
			},
		});
		return res.data.data;
	} catch (error) {
		throw error?.response?.data;
	}
}

export async function fetchCreditNoteDetails(data) {
	const token = getLocalStorageData();
	try {
		const res = await axiosInstanceV2.post(`${APP_API_URL_V2}/sales/credit-note/details`, data, {
			headers: {
				'Content-Type': 'application/json',
				Authorization: `Bearer ${token?.token}`,
			},
		});
		return res.data.data;
	} catch (error) {
		throw error?.response?.data;
	}
}

export async function sendEmail(id, data) {
	const token = getLocalStorageData();
	try {
		const { res } = await axiosInstanceV2.post(
			`${APP_API_URL_V2}/sales/credit-note/${id}/send/email`,
			data,
			{
				headers: {
					Authorization: `Bearer ${token?.token}`,
				},
			},
		);
		return res;
	} catch (error) {
		throw error?.response?.data;
	}
}

export async function generateSalesCreditNotePdf(id, merge = false) {
	try {
		const token = localStorage.getItem('authToken');
		const { data } = await axiosInstanceV2.get(
			`${APP_API_URL_V2}/sales/credit-note/generate-pdf?ids=${id}&merge=${merge}`,
			{
				headers: {
					Authorization: `Bearer ${token}`,
				},
			},
		);
		return data?.data.signed_urls[0];
	} catch (error) {
		throw new Error(error?.response?.data?.message);
	}
}
